/* Mouse-following blue light on box borders (styles in index.css, inspired by
   Stripe's careers grid). Each box gets the cursor position relative to itself
   in --mx/--my; the radial gradients in CSS do the rest, so nearby boxes light
   up too. Mouse only: touch and pen never show it. */
const BOXES = ".modular > section, .modular > header, .modular-footer, .panel, .panel-card, .avatar";
const root = document.documentElement;
let x = 0;
let y = 0;
let frame = 0;

function paint() {
  frame = 0;
  document.querySelectorAll<HTMLElement>(BOXES).forEach((el) => {
    const r = el.getBoundingClientRect();
    if (r.bottom < 0 || r.top > window.innerHeight) return; // off screen
    el.style.setProperty("--mx", `${x - r.left}px`);
    el.style.setProperty("--my", `${y - r.top}px`);
  });
}
const schedule = () => {
  if (!frame) frame = requestAnimationFrame(paint);
};

window.addEventListener(
  "pointermove",
  (e) => {
    if (e.pointerType !== "mouse") return;
    x = e.clientX;
    y = e.clientY;
    root.style.setProperty("--glow", "1");
    schedule();
  },
  { passive: true },
);
window.addEventListener("scroll", schedule, { passive: true });
root.addEventListener("mouseleave", () => root.style.setProperty("--glow", "0"));
